// @flow

import styles from './CardItem.module.css';

export const CardItem = ({ item }) => (
  <div className={styles.CardWrapper}>
    <div className={styles.CardImage}>
      <img alt="landing" src={item.image} />
    </div>
    {/* <div className={styles.CardDetails}>
                <div className={styles.CardTitle}>{item.title}</div>
                <div className={styles.CardDesc}>{item.desc}</div>
                <div className={styles.BorderBox}/>
                <div className={styles.BorderBoxBottom}/>

            </div> */}
  </div>
);
